import Axios from "./axios";

const resource = "contact-us-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}